export default __webpack_public_path__ + "imgs/pulse_icon.svg";